/* eslint-disable no-bitwise */
export default (workflow) => {
  const TSWEB = 0b000001;
  const TSWEB_BANKING = 0b000010;
  const TSWEB_SOCIAL = 0b000100;
  const TSWEB_UTILITY = 0b001000;
  const TSWEB_PAYROLL = 0b010000;
  const TSWEB_CHATBOT = 0b100000;

  const defaultWorkflow = {
    tswebBanking: true,
  };

  if (!workflow) return defaultWorkflow;

  const flags = parseInt(workflow, 16);
  return {
    tswebEnabled: !!(flags & TSWEB),
    tswebBanking: !!(flags & TSWEB_BANKING),
    tswebSocial: !!(flags & TSWEB_SOCIAL),
    tswebUtility: !!(flags & TSWEB_UTILITY),
    tswebPayroll: !!(flags & TSWEB_PAYROLL),
    tswebChatbot: !!(flags & TSWEB_CHATBOT),
  };
};
